import React, { useEffect } from 'react'
import { SimpleLoading } from 'components/LoadingIcon'
import { tutorialTypes } from 'constants/tutorials'
import useRolesViews from 'hooks/useRolesViews'
import useStateBackLink from 'hooks/useStateBackLink'
import useTutorials from 'hooks/useTutorials'
import { useHistory } from 'react-router'
import { PARENT_PAGES } from 'redesign/components/templates/SideMenu/constants'
import PinLoginWrapper from 'redesign/pages/pin-login/pin-login-wrapper'
import SideMenuProvider from 'redesign/services/SideMenu/SideMenuProvider'
import routes from 'services/RoutesProvider/routes'
import AbsencePlannerPage from './AbsencePlannerPage'
import { AbsencePlannerStateProvider } from './contexts/AbsencePlannerStateContext'
import { TaskBarStateProvider } from './contexts/TaskBarStateContext'

const AbsencePlanner: React.FC = () => {
  const { canManageAbsences } = useRolesViews()
  const history = useHistory()
  const { beenShownBefore, isReady } = useTutorials()
  const { setBackLink } = useStateBackLink()

  useEffect(() => {
    if (!isReady) return
    if (canManageAbsences) {
      if (!beenShownBefore('absenceplanManager')) {
        history.replace(`${routes.tutorial}/${tutorialTypes.absencePlanManager}`)
      }
    } else {
      if (!beenShownBefore('absenceplanFrontliner')) {
        history.replace(`${routes.tutorial}/${tutorialTypes.absencePlanFrontliner}`)
      }
    }
  }, [history, isReady, beenShownBefore, setBackLink, canManageAbsences])

  if (!isReady) {
    return (
      <div data-testid="loading-tutorials-absence-planner">
        <SimpleLoading />
      </div>
    )
  }

  return (
    <PinLoginWrapper>
      <TaskBarStateProvider>
        {/* Needed provider for the redesign, pls don't remove, doesn't affect current implementation */}
        <SideMenuProvider parentPage={PARENT_PAGES.absencePlan}>
          <AbsencePlannerStateProvider>
            <AbsencePlannerPage />
          </AbsencePlannerStateProvider>
        </SideMenuProvider>
      </TaskBarStateProvider>
    </PinLoginWrapper>
  )
}

export default AbsencePlanner
